import type * as Pdfjs from 'pdfjs-dist/types/src/pdf';
import type {PdfRotation, ViewedContentViewport} from '../../../lib/mv-viewed-content';
import {exists} from 'shared/utils/custom-utils';

export function calculateOptimalPdfPageScaling(defaultPdfViewport: Pdfjs.PageViewport, viewerViewport: ViewedContentViewport, pdfRotation: PdfRotation): number {
    const pdfWidth = isPdfRotatedSideways(pdfRotation) ? defaultPdfViewport.height : defaultPdfViewport.width;
    const pdfHeight = isPdfRotatedSideways(pdfRotation) ? defaultPdfViewport.width : defaultPdfViewport.height;

    const widthRatio = viewerViewport.width / pdfWidth;
    const heightRatio = viewerViewport.height / pdfHeight;

    return Math.min(widthRatio, heightRatio);
}

export function calculateSidePreviewVisibility(contentViewport: ViewedContentViewport, pdfViewport: Pdfjs.PageViewport | undefined, pdfRotation: PdfRotation): boolean {
    if (!exists(pdfViewport)) {
        return false;
    }

    const viewportValue = isPdfRotatedSideways(pdfRotation) ? pdfViewport.height : pdfViewport.width;

    return (contentViewport.width - viewportValue) / 2 < 100;
}

export function isPdfRotatedSideways(pdfRotation: PdfRotation): boolean {
    return pdfRotation === 90 || pdfRotation === 270;
}